import React from 'react'
import Label from "components/general/Label"
import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnResult, ColumnPoints, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { CellTieRule } from './CellTieRule';

export function TableColumns() {
    return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: 'HeaderLane' }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            {
                Header: <Label data='HeaderReaction' />,
                accessor: 'extendedResults',
                headerClassName: 'text-end w-5',
                className: 'text-end',
                id: 'RT',
                Cell: (props) => {
                    const row = props.cell.row.original;
                    const isFalseStart = row?.extendedResults?.some(er => er?.er_code === 'FALSE_START')
                    return !isFalseStart && row?.extendedResults?.filter(er => er?.er_code === 'REACT_TIME')?.map(val => val?.er_value);
                }
            },
            ColumnResult({}),
            {
                accessor: 'extendedResults',
                id: 'TieRules',
                className: '',
                headerClassName: 'w-5',
                Cell: props => {
                    const row = props.cell.row.original;
                    return <CellTieRule extendedResults={row?.extendedResults} />
                }
            },
            ColumnPoints({}),
            ColumnRecords({}),
            ColumnQualification({}),
            ColumnExpander({})
        ]
    )
}


export default TableColumns
